/**
 * @file useLocalStorage.ts
 *
 * @fileoverview Saves an item in localstorage and allows accessing and changing that item value.
 */

import { useState, useEffect } from 'react';

// Hook
export const useLocalStorage = (key, initialValue) => {
  // State to store our value
  let initial = initialValue;
  const [storedValue, setStoredValue] = useState(initialValue);

  if (typeof localStorage !== 'undefined') {
    initial = localStorage.getItem(key);
  }

  useEffect(() => {
    // when client fires set the locatlstorage value
    setStoredValue(initial);
  }, []);

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);

      // Save to local storage
      window.localStorage.setItem(
        key,
        typeof valueToStore === 'string'
          ? valueToStore
          : JSON.stringify(valueToStore),
      );
    } catch (error) {
      // A more advanced implementation would handle the error case
    }
  };

  const removeValue = () => {
    try {
      // Remove from local storage
      window.localStorage.removeItem(key);
    } catch (error) {}
  };

  return [storedValue, setValue, removeValue];
};
